import { styled } from 'styled-system/jsx'

const PageRoot = styled('div', {
  base: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px 16px',
    background: 'linear-gradient(160deg, #F6F3FF 0%, #FFFFFF 65%)',
  },
})

const CardWrap = styled('div', {
  base: {
    width: '100%',
    maxWidth: '480px',
  },
})

const Content = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
})

const BrandRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
})

const BrandLogo = styled('img', {
  base: {
    height: '32px',
    width: 'auto',
    maxWidth: '120px',
    objectFit: 'contain',
  },
})

const BrandName = styled('span', {
  base: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#5B5470',
  },
})

const Title = styled('h1', {
  base: {
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: 1.25,
    color: '#1A1430',
  },
})

const Body = styled('p', {
  base: {
    fontSize: '15px',
    lineHeight: 1.5,
    color: '#5B5470',
  },
})

const DetailList = styled('dl', {
  base: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    columnGap: '16px',
    rowGap: '8px',
    padding: '14px 0',
    borderTop: '1px solid #E7E3F1',
    borderBottom: '1px solid #E7E3F1',
  },
})

const DetailLabel = styled('dt', {
  base: {
    fontSize: '14px',
    color: '#5B5470',
  },
})

const DetailValue = styled('dd', {
  base: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#1A1430',
  },
})

const TermsText = styled('p', {
  base: {
    fontSize: '14px',
    lineHeight: 1.5,
    color: '#5B5470',
    whiteSpace: 'pre-wrap',
  },
})

const AgreeText = styled('p', {
  base: {
    fontSize: '13px',
    lineHeight: 1.5,
    color: '#5B5470',
  },
})

const ActionRow = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
  },
})

const ErrorText = styled('p', {
  base: {
    fontSize: '14px',
    color: '#B3382C',
  },
})

export {
  PageRoot,
  CardWrap,
  Content,
  BrandRow,
  BrandLogo,
  BrandName,
  Title,
  Body,
  DetailList,
  DetailLabel,
  DetailValue,
  TermsText,
  AgreeText,
  ActionRow,
  ErrorText,
}
